import { supabaseService } from '../db/supabase';
import type { BemPatrimonial } from '../types';

class SyncService {
  async init(): Promise<void> {
    // Offline desabilitado: não há fila local nem sincronização em background.
    return;
  }

  async registrarBem(bem: BemPatrimonial): Promise<void> {
    if (!navigator.onLine) {
      throw new Error('Sem conexão com a internet. Conecte-se para registrar o bem.');
    }

    // Garante que bem.campus é uma string antes de passar para o supabaseService
    if (!bem.campus) {
      throw new Error('Campus não definido no bem a ser registrado.');
    }

    await supabaseService.registrarBemInventario(bem.campus, bem);
    console.log('✅ Bem registrado online');
  }

  async carregarLocais(campusId: string): Promise<any[]> {
    if (!navigator.onLine) {
      throw new Error('Sem conexão com a internet. Conecte-se para carregar os locais.');
    }

    return await supabaseService.buscarLocaisPorCampus(campusId);
  }

  async buscarBemPorTombo(tombo: string): Promise<any | null> {
    if (!navigator.onLine) {
      throw new Error('Sem conexão com a internet. Conecte-se para buscar o bem.');
    }

    return await supabaseService.buscarBemPorTombo(tombo);
  }

  destroy(): void {
    return;
  }
}

export const syncService = new SyncService();
export default syncService;
